import React from 'react';
import { LlmConvoComponent } from './llm-convo-component';
import { Conversation } from '../api/models/Conversation';
import { ImgModalState } from './image-modal';
import { Model, Effort } from '../api/models/CreateMessageInput';

interface FullScreenChatViewProps {
    convo: Conversation | undefined;
    message: string;
    setMessage: (message: string) => void;
    sendMessage: (model: Model, effort?: Effort, messageOverride?: string) => Promise<boolean>;
    questionSuggestions: string[];
    setImgModalState: (state: ImgModalState) => void;
    openCodeModal: (code: string) => void;
    getCitationTextDetails: (conversationId: string, messageId: string, fileId: string) => Promise<string>;
    handleCreateArtifact: (type: 'code' | 'image', data: string) => Promise<void>;
    handleCreateShareLink: (conversationId: string) => void;
    messageInProgress?: boolean;
}

export const FullScreenChatView: React.FC<FullScreenChatViewProps> = ({
    convo,
    message,
    setMessage,
    sendMessage,
    questionSuggestions,
    setImgModalState,
    openCodeModal,
    getCitationTextDetails,
    handleCreateArtifact,
    handleCreateShareLink,
    messageInProgress
}) => {
    return (
        <div className="h-full w-full bg-white/95 border border-white/50 overflow-hidden">
            <div className="h-full overflow-y-auto">
                <LlmConvoComponent
                    createShareLink={handleCreateShareLink}
                    questionSuggestions={questionSuggestions}
                    createArtifact={handleCreateArtifact}
                    openCodeModal={openCodeModal}
                    setImgModalState={setImgModalState}
                    getCitationTextDetails={getCitationTextDetails}
                    convo={convo}
                    message={message}
                    sendMessage={sendMessage}
                    setMessage={setMessage}
                    messageInProgress={messageInProgress}
                />
            </div>
        </div>
    );
};